module.exports = __webpack_public_path__ + "img/08-01_Being Self-Aware.39702855.svg";